module.exports = __webpack_public_path__ + "img/hospitium-03.5b564ba1.jpg";